import { useState } from "react";
import UnansweredQuestions from "./UnansweredQuestions";
import AnsweredQuestions from "./AnsweredQuestions";

/** Mevzuat Soruları — iki sekme, İKİ FARKLI VERİ KAYNAĞI.
 *
 *  Cevaplanmış  → question_log. Ham olay günlüğü: her soruş bir satır,
 *                 IP + müşteri + zaman. Panelden ve tanıtım sitesinden gelen
 *                 sorular birlikte.
 *  Cevaplanmamış → unanswered_questions. Dedupe'lı corpus iş listesi: aynı
 *                 soru tek satır, times_asked sayacı, "Çözüldü" akışı.
 *                 Yalnız panelden gelen sorular (müşteri bazlı çalışma).
 *
 *  İkisini tek tabloya indirmek birini bozardı: dedupe'lı kayıtta "hangi IP
 *  hangi saatte" kaybolur, ham günlükte "kaç kez soruldu / çözüldü mü" kaybolur.
 *  Sekme adları bunu gizlemesin diye alt başlıkta açıkça yazıyor. */
export default function MevzuatSorulari() {
  const [tab, setTab] = useState<"cevaplanan" | "cevapsiz">("cevaplanan");

  return (
    <div className="page">
      <div className="page-head">
        <h1>Mevzuat Soruları</h1>
        <p className="page-sub">
          Mevzuat Analizi'ne sorulan tüm sorular. <strong>Cevaplanmış</strong> sekmesi ham
          günlüktür — kim, nereden, hangi IP ile sordu. <strong>Cevaplanmamış</strong> sekmesi
          corpus iş listesidir: aynı soru tek satırda birleşir, doküman ekleyince
          “Çözüldü” işaretlenir.
        </p>
      </div>

      <div className="tabs">
        <button
          className={"tab" + (tab === "cevaplanan" ? " active" : "")}
          onClick={() => setTab("cevaplanan")}
        >
          Cevaplanmış
        </button>
        <button
          className={"tab" + (tab === "cevapsiz" ? " active" : "")}
          onClick={() => setTab("cevapsiz")}
        >
          Cevaplanmamış
        </button>
      </div>

      {tab === "cevaplanan" ? <AnsweredQuestions /> : <UnansweredQuestions />}
    </div>
  );
}
